import LegalShell from "@/pages/LegalShell";

const Impressum = () => {
  return (
    <LegalShell eyebrow="Rechtliches" title="Impressum">
      <section data-testid="impressum-content">
        <h2 className="font-heading text-lg text-white tracking-tight mb-3">
          Verantwortlich für den Inhalt
        </h2>
        <p>Nils Abel</p>
        <p className="mt-2">
          E-Mail:{" "}
          <a
            href="mailto:info@monowood.ch"
            className="text-[#c88a53] hover:text-[#d99c66] transition-colors"
            data-testid="impressum-email"
          >
            info@monowood.ch
          </a>
        </p>
      </section>

      <section>
        <h2 className="font-heading text-lg text-white tracking-tight mb-3">
          Hinweis
        </h2>
        <p>
          MONOWOOD ist aktuell ein nicht‑kommerzielles Projekt in der
          Konzept‑ und Prototypenphase. Es besteht keine eingetragene
          Gesellschaft. Inhalte dieser Website dienen der Information über das
          Holzbausystem und der Anbahnung von Industriepartnerschaften.
        </p>
      </section>

      <section>
        <h2 className="font-heading text-lg text-white tracking-tight mb-3">
          Haftungsausschluss
        </h2>
        <p>
          Die Inhalte dieser Website wurden mit grösstmöglicher Sorgfalt
          erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der
          Inhalte kann jedoch keine Gewähr übernommen werden. Für externe Links
          ist ausschliesslich der jeweilige Betreiber verantwortlich.
        </p>
      </section>

      <section>
        <h2 className="font-heading text-lg text-white tracking-tight mb-3">
          Urheberrecht
        </h2>
        <p>
          Sämtliche Inhalte dieser Website (Texte, Bilder, Grafiken, technische
          Zeichnungen) sind urheberrechtlich geschützt. Eine Verwendung
          ausserhalb des Rahmens dieses Internetauftritts ist ohne schriftliche
          Zustimmung nicht gestattet.
        </p>
      </section>
    </LegalShell>
  );
};

export default Impressum;
